import { gql } from "lib/apolloClient";

export const productRequestMutation = gql`
  mutation productRequest($input: CreateProductRequestInput!) {
    platform {
      createProductRequest(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const resetProductUpdateReadCountMutation = gql`
  mutation resetProductUpdateReadCount($input: ProductUpdateInputV2!) {
    cms {
      resetUserProductUpdateNewCountV2(input: $input)
    }
  }
`;
